// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconZoom: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <path
                d="M205.634375,1037.86563 L201.893749,1034.125 C202.744374,1032.86219 203.164062,1031.28438 202.939374,1029.60312 C202.557186,1026.74219 200.211874,1024.41562 197.348749,1024.05313 C193.092499,1023.51437 189.514374,1027.09312 190.054999,1031.34687 C190.4175,1034.21062 192.744687,1036.55625 195.605,1036.9375 C197.286562,1037.16222 198.864375,1036.74266 200.126875,1035.89188 L203.867501,1039.6325 C204.355626,1040.12062 205.147189,1040.12062 205.635314,1039.63251 C206.121876,1039.14688 206.121876,1038.35312 205.634375,1037.86563 L205.634375,1037.86563 Z M199,1031.25 L197.221876,1031.25 L197.221876,1033 C197.221876,1033.41438 196.88625,1033.75 196.5,1033.75 C196.084375,1033.75 195.75,1033.41562 195.75,1033 L195.75,1031.25 L193.971875,1031.25 C193.584375,1031.25 193.25,1030.91563 193.25,1030.5 C193.25,1030.08437 193.585625,1029.75 193.971875,1029.75 L195.75,1029.75 L195.75,1028 C195.75,1027.58562 196.085626,1027.25 196.471876,1027.25 C196.858126,1027.25 197.221876,1027.58438 197.221876,1028 L197.221876,1029.75 L198.971876,1029.75 C199.415625,1029.75 199.75,1030.08437 199.75,1030.5 C199.75,1030.91563 199.415625,1031.25 199,1031.25 Z"
                transform="translate(-190 -1024)"
            />
        </svg>
    );
};

export default React.memo(IconZoom);
